import React from 'react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, EffectFade, EffectCoverflow } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper-bundle.css';

SwiperCore.use([Navigation , EffectFade, A11y]);
class MainSlider extends React.Component {	
  constructor(props){
    super(props);
  }

  render() {
    if (!Object.keys(this.props.page_data).length) return <section className="section" />;
    let handleClickBelow = this.props.handleClickBelow;
    let pageData = this.props.page_data;
    let sliders = this.props.page_data.acf ? this.props.page_data.acf.main_slider.slide : [];
    let logo = this.props.page_data.acf ? this.props.page_data.acf.main_slider.logo : [];
    let sliderData = sliders.map((item, key) => {
        return (
            <SwiperSlide key={key}>
                <figure><img className="fullScreen" src={item.image.url} alt={item.image.alt} title={item.image.title} /></figure>
                <figcaption>
                    <div className="main-container">
                        <h6 className="title">{item.heading}</h6>
                        <a href={ item.link } className="btn-arw right">{item.link_text}</a>
                    </div>
                </figcaption>
            </SwiperSlide>
        )
    })
    return (
        <section className="section" data-hammenu="white">
            <div className="ll__inner--hero">
                <Swiper effect="fade" navigation>
                    {sliderData}
                </Swiper>
                <a href="javascript:" id="btn--scroll-down"  onClick={handleClickBelow}></a>
                {
                    pageData &&
                        <div className="bottom-content">
                            <div className="main-container">
                                <h1 className="title-xl">{pageData.title.rendered}</h1>
                            </div>
                        </div>

                }
            </div>
        </section>
    );
  }
}

export default MainSlider;



// WEBPACK FOOTER //
// ./src/components/Services/MainSlider.js